export enum DynamicFilterType {
  input = 'input',
  checkbox = 'checkbox',
  dropdown = 'dropdown',
  multiselect = 'multiselect',
  date = 'date',
  range = 'range',
  datetimeduration = 'datetimerange',
}
